import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Keys, StorageService} from '../service/storage.service';

@Injectable()
export class PanBackLinkResolver implements Resolve<string> {
    private storageService: StorageService;

    constructor(storageService: StorageService) {
        this.storageService = storageService;
    }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
        if (state.url.startsWith('/borrow')) {
            return;
        } else if (state.url.startsWith('/invest') && this.storageService.getItem(Keys.REFERRER_CODE)) {
            return '/invest/referral-consent';
        } else {
            return '/lenderintro';
        }
    }
}
